<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col cols="12">
                <ESGScopeConversionTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ESGScopeConversionTable from '@/components/lists/derived/ESGScopeConversionTable'
export default {
    name:'ESGScopeConversionPage',
    components:{
        ESGScopeConversionTable
    }
}
</script>